<template>
    <div v-show="loaded">
        <div class="que1-mod" v-if="count>0">

            <div v-if="$route.name == 'Store'">ဖြေဆိုရန် {{count}} Quest</div>
            <div v-else class="btn btn-sm btn-yell" @click="_goStore">ဖြေဆိုရန် {{count}} Quest</div>
            <!-- <div @click="_checkBalance" class="btn btn-sm btn-yell">Quest ထပ္မံယူရန္</div> -->
            <div class="btn btn-blue btn-block flex-item-block" @click="_startAn">မေးခွန်းဖြေဆိုရန်</div>
        </div>
        <div class="que2-mod" v-else>
            <div class="no-ques textcenter">
                <div class="btn btn-sm btn-yell" @click="_goStore">ဖြေဆိုရန်{{count}} Quest</div>
                <!-- <p>99Ks ျဖင့္ အပို Quest ကိုရယူပါ</p> -->
                <!-- <div @click="_checkBalance" class="btn btn-sm btn-yell">Quest ထပ္မံယူရန္</div> -->
            </div>
            <!-- <a :href="'http://questtomio.com/checking.php?action=PULL'" class="btn btn-sm btn-yell btn-block">ယခုဝယ္ယူရန္</a> -->
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: 'Question',
    data(){
        return {
            loaded: false,
            count: 0
        }
    },
    computed:{
        ...mapState(['lang'])
    },
    created(){
        if(typeof this.$route.query.mobile != 'undefined'){
            this._fetchCookiesInfo();
        }else{
            this._fetchInfo();
        }
    },
    methods:{
        _fetchInfo(){
            Utils.$ajax({
                url: '/user/info',
            }).done(res =>{
                this.loaded = true;
                if (res.code != 0){
                    //this.$toast(res.msg);
                    return;
                }
                this.count = res.data.question_count;
            })
        },
        _fetchCookiesInfo(){
            let reqData = {mobile: this.$route.query.mobile}
            if(typeof this.$route.query.mobile === 'undefined'){
                reqData = {mobile: localStorage.A_mobile}
            }
            console.log(reqData);
            Utils.$ajax({
                type: 'post',
                url: '/login/check',
                data: reqData,
            }).done(res=>{
                if(res.code==0){
                    localStorage.A_uuid = res.data.uuid;
                    localStorage.A_token = res.data.token;
                    localStorage.A_mobile = res.data.mobile;
                    this._fetchInfo();
                }else{
//                    this.$toast(res.msg);
                }
            })
        },
        _startAn(){
            this.$router.push(`/answer`);
        },
        _goStore(){
            this.$router.push('/store');
        },
        _checkBalance(){
            let url = 'http://home.questtomio.com/checking.php?action=PULL';
            window.location = url + '&mobile=' + localStorage.A_mobile;
            return ;
            let reqData = {mobile: localStorage.A_mobile}
            Utils.$ajax({
                type: 'post',
                url: '/api/check',
                data: reqData,
            }).done(res=>{
                if(res.code == 0){
                    if(res.data.code != 0){
                        this.$messagebox_lang(res.data.message);
                        return;
                    }else{
                        window.location = url + '&mobile' + localStorage.A_mobile;
                    }
                }
//                console.log(res);
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.que1-mod {
    margin-top: rem(30);
    height: rem(180);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
    color: #000;
}

.que2-mod {
    margin-top: rem(30);
    height: rem(180);
    text-align: center;
    color: #000;

    p {
        line-height: 2em;
    }

    .no-ques{
        display: flex;
        justify-content: space-around;
        margin-bottom: rem(30);
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Question.vue